<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Telefonnummer hinterlegen"}}</h4>
</div>

<div class="modal-body">
    {{#if errors.error}}
        <div class="alert alert-danger">{{TR errors.error}}</div>
    {{/if}}

    <div class="wizard-header two clearfix">
        <ul class="steps">
            <li id="tab-1" class="js-wizard-tab first {{#COMPARE activeTab '==' 1}}current{{else}}disabled{{/COMPARE}}">
                <div>
                    <span class="number">1.</span> {{TR "Telefonnummer"}}
                </div>
            </li>
            <li id="tab-2" class="js-wizard-tab {{#COMPARE activeTab '==' 2}}current{{else}}disabled{{/COMPARE}}">
                <div>
                    <span class="number">2.</span> {{TR "Bestätigung"}}
                </div>
            </li>
        </ul>
    </div>

    {{#COMPARE activeTab '==' 1}}
    <div class="row m-t-20">
        <div class="col-xs-12">
            <p>{{TR "Für Benachrichtigungen per SMS benötigen wir eine Mobiltelefonnummer."}}</p>
            <p>{{{TR "Sie erhalten sofort eine SMS mit einem Bestätigungscode, den Sie auf der nächsten Seite eingeben müssen."}}}</p>

            <label class="control-label">{{TR "Telefonnummer"}}</label>
            <input id="ct-phone" type="text" class="form-control js-phone {{#if errors.phone}}parsley-error{{/if}}" value="{{phone}}" placeholder="{{TR "Mobiltelefonnummer"}}">
            </input>
            {{#if errors.phone}}
            <ul class="parsley-errors-list filled">
                <li class="parsley-required">{{errors.phone}}</li>
            </ul>
            {{/if}}
        </div>
    </div>
    {{/COMPARE}}
    {{#COMPARE activeTab '==' 2}}
    <div class="row m-t-20">
        <div class="col-xs-12">
            <p>{{TR "Ihre Telefonnummer: "}} <strong>{{phone}}</strong>
            <p>{{TR "Sie werden eine SMS mit einem Bestätigungscode erhalten. Bitte geben Sie den Code ein um Ihre Telefonnummer zu aktivieren."}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <label class="control-label">{{TR "Bestätigungscode"}}</label>
            <input type="text" class="form-control js-code {{#if errors.code}}parsley-error{{/if}}" value="{{code}}" placeholder="{{TR "XXXXXX (Bestätigungscode)"}}">
            </input>
            {{#if errors.code}}
            <ul class="parsley-errors-list filled">
                <li class="parsley-required">{{errors.code}}</li>
            </ul>
            {{/if}}
        </div>
    </div>
    {{/COMPARE}}
</div>

<div class="modal-footer">
    <button id="js-btn-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Abbrechen"}}
    </button>
    <button class="btn btn-white" {{#COMPARE activeTab '==' 1}}disabled{{/COMPARE}} id="js-btn-prev">
        <i class="glyphicon glyphicon-chevron-left"></i> {{TR "Zurück"}}
    </button>
    {{#COMPARE activeTab '==' 1}}
    <button class="btn btn-primary" {{#unless canNext}}disabled{{/unless}} id="js-btn-next">
        {{#if waitNext}}<i class="fa fa-spin fa-spinner"></i> {{/if}}{{TR "Weiter"}} <i class="glyphicon glyphicon-chevron-right"></i>
    </button>
    {{/COMPARE}}
    {{#COMPARE activeTab '==' 2}}
    <button class="btn btn-primary" {{#unless canFinish}}disabled{{/unless}} id="js-btn-save">
        {{#if waitSave}}<i class="fa fa-spin fa-spinner"></i> {{/if}}{{TR "Speichern"}}
    </button>
    {{/COMPARE}}
</div>
